export default "__VITE_ASSET__409dfc16__"